<template>
  <el-dialog title="选择HS商品编码"
    :visible.sync="visible"
    width="600px"
    append-to-body=""
    @closed="handleClosed">
    <el-form :inline="true"
      @submit.native.prevent>
      <el-form-item>
        <el-input placeholder="HS商品编码"
          v-model="config.hsCode"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input placeholder="商品名称"
          v-model="config.hsName"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary"
          @click="handleCurrentPageChange(1)">查询</el-button>
      </el-form-item>
    </el-form>
    <el-table ref="table"
      @current-change="handleCurrentChange"
      highlight-current-row
      border
      max-height="400"
      v-loading="loading"
      :data="list">
      <el-table-column width="50">
        <template slot-scope="{row}">
          <el-radio v-model="currentRow.hsCode"
            :label="row.hsCode">&nbsp;</el-radio>
        </template>
      </el-table-column>
      <el-table-column label="HS商品编码"
        prop="hsCode">
      </el-table-column>
      <el-table-column label="商品名称"
        prop="hsName"></el-table-column>
      <!-- <el-table-column label="监管类别">
        <template slot-scope="{row}">
          <el-tag v-if="row.legalTest === 0">非法检</el-tag>
          <el-tag type="danger"
            v-if="row.legalTest === 1">法检</el-tag>
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination background
      @current-change="handleCurrentPageChange"
      :current-page.sync="config.pageNum"
      :page-size="config.pageSize"
      layout="total, prev, pager, next"
      :total="total">
    </el-pagination>
    <div slot="footer">
      <el-button @click="toggleModal(false)">取 消</el-button>
      <el-button type="primary"
        @click="add">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'code-select-modal',
  props: {
    callback: Function
  },
  data () {
    return {
      loading: false,
      visible: false,
      list: [],
      config: {
        pageNum: 1,
        pageSize: 10,
        hsName: '',
        hsCode: ''
      },
      total: 0,
      currentRow: {}
    }
  },
  methods: {
    toggleModal (visible) {
      this.visible = visible
    },
    handleClosed () {
      this.currentRow = {}
    },
    add () {
      if (!this.currentRow.hsCode) {
        this.$message.error('请选择HS商品编码')
        return
      }
      this.callback && this.callback(this.currentRow)
      this.toggleModal(false)
    },
    handleCurrentChange (val) {
      this.currentRow = val || {}
    },
    handleCurrentPageChange (current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList (cb) {
      this.loading = true
      this.$store.dispatch('common/gethscodes', {
        payload: this.config,
        success: res => {
          this.loading = false
          this.list = res.data.records
          this.total = res.data.total
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch () {
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.search-form {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
</style>
